var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Cookies from 'js-cookie';
import store from 'store2';
import { createHttpRequest } from '../api';
import { AUTH_TOKEN_KEY, COOKIE_FOR_COUNTDOWN_TIMESTAMP, COOKIE_FOR_MOBILE_NAME, COOKIE_FOR_POSSIBLE_EXISTING_CUSTOMER_NAME, COOKIE_FOR_SESSION_NAME, IR_CLICK_ID_COOKIE_NAME, LOGIN_REFERRER_KEY, RAF_ID_COOKIE_NAME, } from '../constants';
import { raisinDistributorRegflows } from '../constants/distributors';
import { HttpMethod, Service } from '../enums';
import { isCSR } from './domain';
import { getUrlParamByKey, removeUrlParamByKey } from './helpers';
export const getDomain = () => {
    if (isCSR()) {
        const domainParts = window === null || window === void 0 ? void 0 : window.location.host.split('.');
        domainParts.shift();
        /**
         * Set the 'domain' attribute of the cookie to e.g. .weltsparen.de
         * so it is also accessible on Public Website
         *
         * or
         *
         * set it to whatever the domain is, if on localhost
         */
        return domainParts.length <= 1 ? '' : `.${domainParts.join('.')}`;
    }
    else {
        return null;
    }
};
export const hasCookieForMobile = () => {
    const cookie = Cookies.get(COOKIE_FOR_MOBILE_NAME);
    return !!cookie && cookie === 'true';
};
export const hasCookieForSession = () => {
    const cookie = Cookies.get(COOKIE_FOR_SESSION_NAME);
    return !!cookie && cookie === 'true';
};
export const hasValidJwt = () => {
    const authToken = store.local.get(AUTH_TOKEN_KEY);
    return !!authToken && !!authToken.access_token;
};
export const hasCookieForPossibleExistingCustomer = () => !!Cookies.get(COOKIE_FOR_POSSIBLE_EXISTING_CUSTOMER_NAME);
/**@deprecated */
export const createCookieForSession = () => {
    const inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);
    Cookies.set(COOKIE_FOR_SESSION_NAME, 'true', {
        expires: inFifteenMinutes,
        domain: getDomain(),
        path: '/',
    });
};
/**@deprecated This relies on OBS functionality */
export const refreshCookieForSession = () => createCookieForSession();
/**@deprecated this relies on OBS functionality */
export const deleteCookieForSession = () => Cookies.remove(COOKIE_FOR_SESSION_NAME, { path: '/', domain: getDomain() });
export const deleteAuthToken = () => {
    if (isCSR()) {
        localStorage.removeItem(AUTH_TOKEN_KEY);
    }
};
export const removeAutoLogoutTimestamp = () => {
    if (isCSR()) {
        localStorage.removeItem(COOKIE_FOR_COUNTDOWN_TIMESTAMP);
    }
};
/**
 * Sets regflow cookie with expiry & path.
 *
 * @returns void
 */
export const setCookieRegflow = () => {
    const localesList = [
        'en',
        'en-us',
        'en-gb',
        'en-ie',
        'de-de',
        'de-at',
        'es-es',
        'fr-fr',
        'nl-nl',
        'pl-pl',
        'fi-fi',
    ];
    const locale = window.location.pathname.split('/')[1];
    const cookieValue = getUrlParamByKey('regflow');
    let path = '/';
    if (cookieValue) {
        if (window.location.host.includes('raisin.com') && localesList.includes(locale)) {
            path = `/${locale}`;
        }
        Cookies.set('regflow', cookieValue, {
            expires: 30,
            domain: getDomain(),
            path,
        });
    }
};
/**
 * Sets state cookie with expiry & path.
 *
 * @returns void
 */
export const setCookieState = () => {
    const partner = 'state';
    const cookieValue = getUrlParamByKey(partner);
    let path = '/';
    const fourHoursInMs = 4 * 60 * 60 * 1000;
    const expirationDate = new Date(new Date().getTime() + fourHoursInMs);
    if (cookieValue) {
        Cookies.set(partner, cookieValue, {
            expires: expirationDate,
            path,
            domain: getDomain(),
        });
    }
};
/**
 * Retrieve the regflow value from the url param or from the Cookies
 *
 * @returns string
 */
export const getRegFlowParam = () => getUrlParamByKey('regflow') || Cookies.get('regflow');
/**
 * Determines which distributor is being used on the current page.
 *
 * @returns string
 */
export const getDistributor = () => {
    const value = getRegFlowParam();
    if (!value || raisinDistributorRegflows.includes(value)) {
        return 'Raisin';
    }
    return value;
};
export const createLoginRefererLink = () => {
    if (!isCSR())
        return '';
    return window.location.pathname + window.location.search + window.location.hash;
};
export const setLoginReferer = ({ refererLink } = { refererLink: undefined }) => {
    if (!isCSR())
        return;
    const referer = refererLink !== null && refererLink !== void 0 ? refererLink : createLoginRefererLink();
    sessionStorage.setItem(LOGIN_REFERRER_KEY, referer);
};
export const getLoginReferer = () => {
    if (!isCSR()) {
        return null;
    }
    return sessionStorage.getItem(LOGIN_REFERRER_KEY);
};
export const clearLoginReferer = () => {
    sessionStorage.removeItem(LOGIN_REFERRER_KEY);
};
export const getIRClickId = () => {
    const irclickId = getUrlParamByKey(IR_CLICK_ID_COOKIE_NAME) || Cookies.get(IR_CLICK_ID_COOKIE_NAME);
    return irclickId ? { irclickid: irclickId } : null;
};
export const storeBrokerInCookies = () => {
    const regFlow = getUrlParamByKey('regflow');
    const salesId = getUrlParamByKey('salesid');
    if (regFlow && salesId) {
        const cookieData = JSON.stringify({
            sgBrokerId: salesId,
            sgBrokerNetwork: regFlow,
        });
        Cookies.set('sg_core_broker', cookieData, {
            expires: 12,
            secure: true,
            path: '/',
            sameSite: 'strict',
        });
    }
};
export const storeClickId = (userInteractionState) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const clickId = getUrlParamByKey(IR_CLICK_ID_COOKIE_NAME);
    // Check if the user has given consent to "Impact Radius" tracking
    const impactConsentStatus = (_a = window === null || window === void 0 ? void 0 : window['UC_UI']) === null || _a === void 0 ? void 0 : _a.getServicesBaseInfo().find((data) => data.id === 'ha-q9XBo').consent.status;
    if (clickId && userInteractionState === 'true') {
        if (impactConsentStatus) {
            Cookies.remove(IR_CLICK_ID_COOKIE_NAME);
            Cookies.set(IR_CLICK_ID_COOKIE_NAME, clickId, {
                expires: 30,
                secure: true,
            });
            window.history.pushState('', '', removeUrlParamByKey(IR_CLICK_ID_COOKIE_NAME));
        }
        else {
            // remove irclickid from cookies if consent is denied
            Cookies.remove(IR_CLICK_ID_COOKIE_NAME);
            createHttpRequest({
                service: Service.IS,
                url: '/store',
                method: HttpMethod.POST,
                data: { irclickid: clickId },
                settings: {
                    withCredentials: true,
                },
            })
                .then(() => {
                window.history.pushState('', '', removeUrlParamByKey(IR_CLICK_ID_COOKIE_NAME));
            })
                .catch((error) => {
                // eslint-disable-next-line no-console
                console.error(error);
            });
        }
    }
    else if (userInteractionState === 'true' && !impactConsentStatus) {
        // remove irclickid from cookies if consent is denied
        Cookies.remove(IR_CLICK_ID_COOKIE_NAME);
    }
});
export const storeRafIdInCookies = () => {
    const rafId = getUrlParamByKey(RAF_ID_COOKIE_NAME);
    if (rafId) {
        Cookies.set(RAF_ID_COOKIE_NAME, rafId, {
            expires: 30,
            secure: true,
        });
    }
};
//# sourceMappingURL=clientStorage.js.map